/* 🤖 this file was generated by svg-to-ts */
export const matIconKeyboardHide: {
  name: 'keyboard-hide';
  data: string;
} = {
  name: 'keyboard-hide',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 3H4c-1.1 0-1.99.9-1.99 2L2 15c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12H4V5h16v10zm-9-9h2v2h-2zm0 3h2v2h-2zM8 6h2v2H8zm0 3h2v2H8zM5 9h2v2H5zm0-3h2v2H5zm3 6h8v2H8zm6-3h2v2h-2zm0-3h2v2h-2zm3 3h2v2h-2zm0-3h2v2h-2zm-5 17 4-4H8z"/></svg>`
};
